<template>
    <ul class="u-error-container">
        <slot />
    </ul>
</template>